var React = require('react');

function BurgerMenu (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t\t.st0 {\n\t\t\tfill: #66EBAF;\n\t\t}\n\t"),React.createElement("g",{"key":1},React.createElement("rect",{"className":"st0","width":"55","height":"4"})),React.createElement("g",{"key":2},React.createElement("rect",{"y":"18","className":"st0","width":"55","height":"4"})),React.createElement("g",{"key":3},React.createElement("rect",{"y":"9","className":"st0","width":"55","height":"4"}))]);
}

BurgerMenu.defaultProps = {"version":"1.1","id":"Burger_Menu","x":"0px","y":"0px","viewBox":"0 0 55 22","style":{"enableBackground":"new 0 0 55 22"},"xmlSpace":"preserve"};

module.exports = BurgerMenu;

BurgerMenu.default = BurgerMenu;
